import React from 'react';
import { Box, Typography } from '@mui/material';
import { LuLightbulb } from 'react-icons/lu';
import { elliottTokens as t } from '../tokens';
import { messageBodySx } from './ElliottMessage';

// Inline "TAKEAWAY" callout — subtle orange-tint gradient card with a brandy label.
const TakeawayCard: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      px: '16px',
      py: '12px',
      borderRadius: '8px',
      background: 'linear-gradient(180deg, rgba(247,148,32,0.1) 0%, rgba(241,90,38,0.1) 100%)'
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Typography
        sx={{
          // Match the ELLIOTT label exactly (size / weight / tracking / brandy gradient).
          fontSize: 14,
          fontWeight: 700,
          letterSpacing: '1.8px',
          lineHeight: 'normal',
          backgroundImage: t.brandyTextGradient,
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          color: 'transparent'
        }}
      >
        TAKEAWAY
      </Typography>
      <Box sx={{ display: 'flex', color: t.brandLight }}>
        <LuLightbulb size={18} />
      </Box>
    </Box>
    <Typography sx={messageBodySx}>{children}</Typography>
  </Box>
);

export default TakeawayCard;
